import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import RelatorioAlunoForm from './RelatorioAlunoForm';
import Grid from '@mui/material/Grid';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
        backgroundColor: '#f5f5f5',
    },
    title: {
        margin: '20px'
    },
    adicionarDisciplina: {
        paddingBottom: '10px',
    },
    formControl: {
        marginBottom: '10px'
    }
});

export default function RelatorioAlunoContainer() {
    const classes = useStyles();

    return (
        <div>
            <Container  >
                <Typography className={classes.title} variant="h5">
                    Relatório
                </Typography>
                <Grid container spacing={3} >
                    <Grid size={8}>
                        <RelatorioAlunoForm />
                    </Grid>
                </Grid>



            </Container>
        </div>
    );
}